module.exports = __webpack_public_path__ + "static/ask-about-social-covid-d3d74e83e839f53877f51bde631f3bd7.jpg";